import styled, { css, gapSize, tablet } from 'theme';

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${gapSize(2)};
  flex-wrap: wrap;

  button {
    width: 100%;

    ${tablet(css`
      width: unset;
    `)}
  }
`;
